import React from 'react'

import { CircleLoader, Div, P } from '@driftt/tide-core'

const Loading = () => (
  <Div className="app-loading-placeholder">
    <CircleLoader size="large" className="placeholder-spinner" />
    <P>Just a moment...</P>
  </Div>
)

export default Loading
